export default __webpack_public_path__ + "static/12.07-42068ec31bca19168b5dd180370fe9e9.png";